import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  disabledOptionWrapper: {
    width: '100%',
    pointerEvents: 'auto',
    cursor: 'not-allowed',
  },
}))

export default useStyles
